import axios from 'axios';
import { APIChatUrl, APITokenUrl } from '../../../Utils/Utils';

export const submitFeedback = (payload) => {
  return axios({
    method: 'POST',
    headers: {
      'access-control-allow-origin': '*',
      'content-type': 'application/json',
      'X-API-Key': APITokenUrl(),
    },
    data: payload,
    url: `${APIChatUrl()}/chat/feedback`,
  });
};
